import {CategoryFilter} from './category-filter';
import {Filter} from './filter';
import {useGetKosherFilter} from "@framework/filters/get-kosher-filter";
import React from "react";
import {useTranslation} from "../../app/i18n/client";
import SelectedFilters from "@components/search/selected-filters";
import {useFetchManufacturersFilter} from "@framework/filters/get-manufacturers-filter";
import {MultiKeyFilter} from "@components/search/MultiKeyFilter";

export const ShopFilters: React.FC<{ lang: string }> = ({ lang }) => {
    const {t} = useTranslation(lang)
    const {
        data: kosherItems,
        isLoading: isKosherFilterLoading,
        error: kosherItemsError
    } = useGetKosherFilter()

    const {
        data: manufacturersItems,
        isLoading: isManufacturersFilterLoading,
        error: manufacturersFilterError
    } = useFetchManufacturersFilter()

  return (
    <div className="space-y-10">
        <SelectedFilters lang={lang}/>
        <MultiKeyFilter lang={lang}
                filterItems={[{
                    id: 1,
                    key: "hide_out_of_stock",
                    label_de: t('common:text-hide-out-of-stock'),
                    label_en: t('common:text-hide-out-of-stock'),
                    label_fr: t('common:text-hide-out-of-stock'),
                    label_he: t('common:text-hide-out-of-stock'),
                    slug: "hide-out-of-stock",
                    children: []
                },
                    {
                        id: 2,
                        key: "kosher_pesach",
                        label_de: t('common:text-show-only-kosher_pesach-product'),
                        label_en: t('common:text-show-only-kosher_pesach-product'),
                        label_fr: t('common:text-show-only-kosher_pesach-product'),
                        label_he: t('common:text-show-only-kosher_pesach-product'),
                        slug: "show-only-pesach-kosher",
                        children: []
                    },
                    {
                        id: 3,
                        key: "on_sale",
                        label_de: t('common:text-show-only-on_sale-product'),
                        label_en: t('common:text-show-only-on_sale-product'),
                        label_fr: t('common:text-show-only-on_sale-product'),
                        label_he: t('common:text-show-only-on_sale-product'),
                        slug: "show-only-on_sale",
                        children: []
                    }
                ]}/>
      <CategoryFilter lang={lang} />
        <Filter lang={lang}
            queryName={'kosher'}
            filterItems={kosherItems ?? []}
            isLoading={isKosherFilterLoading}
            error={kosherItemsError}/>
        <Filter lang={lang}
                queryName={'manufacturer'}
                filterItems={manufacturersItems ?? []}
                isLoading={isManufacturersFilterLoading}
                error={manufacturersFilterError}/>
    </div>
  );
};
